<template>
  <SidebarComponent v-if="$route.meta.domain != 'documentation'"/>
  <SidebarDocumentation v-else/>
  <div class="wrapper">
    <HeaderComponent/>
    <router-view></router-view>
    <FooterComponent v-if="!Hasfooter.includes($route.name)" />
  </div>
</template>

<script>
import HeaderComponent from "../HeaderComponent";
import SidebarComponent from "../SidebarComponent";
import FooterComponent from "../FooterComponent";
import SidebarDocumentation from "../SidebarDocumentation.vue";

export default {
  name: 'AuthLayoutComponent',
  components:{
    HeaderComponent,
    SidebarComponent,
    SidebarDocumentation,
    FooterComponent
  },
  data(){
    return {
      Hasfooter:['Email App','Chat app','Social App','File Manager','Tasks','Project List'],
    }
  },
  mounted(){
    document.body.className = 'layout-1';
  },
}
</script>